import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";//NEW
import CustomModal from "../../components/CustomModal/CustomModal";
import useUtenti from "../../hooks/useUtenti";
import InputUserinfo from "../../components/InputUserInfo/InputUserInfo";
import UserInfo from "../../components/UserInfo/UserInfo";
import { useSelector } from "react-redux";
import UtilityService from "../../services/UtillityServices/UtilityService";
import { ROLES } from "../../model/roles";
import CreateUser from "../../components/CreateUser/CreateUser";
import useMediaQuery from "../../hooks/useMediaQuery";
import { alertService } from "../../services/AlertService";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import LoadingTable from "../../components/LoadingTable/LoadingTable";
import CustomFilterTable from "../../components/CustomFilterTable/CustomFilterTable";
import UpdateUserPendingForm from "../../components/Forms/UpdateUserPendingForm/UpdateUserPendingForm";
import CustomTable from "../../components/CustomTable/CustomTable";
import useUserConfigTable from "../../configTable/useUserConfigTable";
import { ACTION_TYPES } from "../../model/actions";
import useClassiUtenti from "../../hooks/useClassiUtenti";
import AssegnaCorsiModal from "../../components/AssegnaCorsiModal/AssegnaCorsiModal";
import { useNavigate } from "react-router";
import useSconti from "../../hooks/useSconti";
import AssegnaScontoManager from "../../components/AssegnaScontoManager/AssegnaScontoManager";
import ClassiListManager from '../../components/ClassiListManager/ClassiListManager';
import useCorsiUtenti from "../../hooks/useCorsiUtenti";
import { TIPO_CORSO } from "../../model/tipoCorso";

const GestioneUtentiPage = () => {
  const location = useLocation();//NEW
  const formatCourseData = location.state?.formatCourseData || null;//NEW

  const {
    loadingStateUtenti,
    modalStateUtenti,
    setModalStateUtenti,
    createUtente,
    resendEmail,
    getUtenteByParams,
    disableUtente,
    deleteUtente
  } = useUtenti();

  const { setModalStateSconti, modalStateSconti } = useSconti();

  const { 
    createClassiUtenti, 
    modalStateClassiUtenti,
    setModalStateClassiUtenti
  } = useClassiUtenti();

  const {
    assignCourseToUser,
    loadingStateCorsiUtenti
  } = useCorsiUtenti();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [utenti, setUtenti] = useState([]);
  const [selectedUtente, setSelectedUtente] = useState(null);
  const [formCreateUtente, setFormCreateUtente] = useState({});
  const userLoggedIn = useSelector((state) => state?.user?.userData);
  const [selectedAgenzia, setSelectedAgenzia] = useState(null);
  const [corsiUtentiAssignedPerUser, setCorsiUtentiAssignedPerUser] = useState([]);
  const [formDataUpdateUserPending, setFormDataUpdateUserPending] = useState([]);
  const navigate = useNavigate();
  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingUtenti, setIsLoadingUtenti] = useState(false);

  const userConfigTable = useUserConfigTable();

  useEffect(() => {
    if (!isLoadingUtenti) {
      printAllUtenti();
    }
  }, [orderBy, orderType, selectedPage])

  useEffect(() => {
    if (formatCourseData) {
      setModalStateUtenti((state) => ({ ...state, showModalCreateUtente: true }));
      //setCorsiUtentiAssignedPerUser([formatCourseData.id_classe]); // Preseleziona il corso
    }
  }, [formatCourseData]);

  const fetchUtenti = async (obj) => {
    setIsLoadingUtenti(true);
    let utentiList;
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };

    if(userLoggedIn.role === ROLES.COURSE_DESIGNER){
      obj = {
        ...obj,
        filtri: {
          ...obj.filtri,
          tipo_utente: ["partner"]
        }
     }
    }

    if (userLoggedIn?.role === ROLES.PARTNER) {
      obj = {
        ...obj,
        filtri: {
          ...obj.filtri,
          id_agenzia: userLoggedIn?.id_agenzia,
        }
      };
    }
  
    console.log(obj);
    const fetchUtentiList = await getUtenteByParams(obj);
    const countPagination = Math.ceil(fetchUtentiList?.count / obj.limite);
    setTotalPages(countPagination);
    utentiList = fetchUtentiList?.data ?? [];
    setUtenti(utentiList);
    setIsLoadingUtenti(false);
    if(utentiList?.length === 0){
      setSelectedPage(1)
    }
  };
  
  const printAllUtenti = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
        attivo: 1
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: 'ultima_data_iscrizione_corso desc, ' + `${orderBy ?? "data_inserimento"} ${orderType ?? "desc"}`
    };
  
    await fetchUtenti(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
    let obj = {
      filtri: {
        ...formDataFilter,
        attivo: 1
      },
      limite: 10,
      pagina: 1,
      ordinamento: 'ultima_data_iscrizione_corso desc, ' + `${orderBy ?? "data_inserimento"} ${orderType ?? "desc"}`
    };
    await fetchUtenti(obj);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const openInfoModal = (user) => {
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalInfoUtente: true }));
  };

  const openModalCreateUtente = () => {
    setSelectedAgenzia(null);
    setCorsiUtentiAssignedPerUser([]);
    setModalStateUtenti((state) => ({ ...state, showModalCreateUtente: true }));
  };

  const openEditModal = (user) => {
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalUpdateUtente: true }));
  };

  const openDeleteModal = (user) => {
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalDeleteUtente: true }));
  };

  const openDisableModal = (user) => {
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalDisableUtente: true }));
  };

  const handleCloseModal = () => {
    setSelectedAgenzia(null);
    setSelectedUtente(null);
    setCorsiUtentiAssignedPerUser([]);
    setModalStateUtenti((state) => ({
      ...state,
      showModalCreateUtente: false,
      showModalUpdateUtente: false,
      showModalDeleteUtente: false,
      showModalDisableUtente: false,
      showModalInfoUtente: false,
    }));
    setModalStateSconti((state) => ({ ...state, showModalCreateSconto: false }));
    setModalStateClassiUtenti((state) => ({ ...state, showModalViewClassiList: false }));
  };


  const onCreateUtente = async () => {
    const requiredFields = ["nome", "cognome", "email", "ruolo"];
    const missingFields = UtilityService.validationForm(
      formCreateUtente,
      requiredFields
    );
    if (missingFields?.length > 0) {
      const formattedMissingFields = missingFields.join(", ");
      alertService.warn(`I seguenti campi sono obbligatori: ${formattedMissingFields}`, {autoClose: true});
      return;
    }
    if(!UtilityService.isValidEmail(formCreateUtente?.email)) {
      alertService.warn("L'email non è valida", { autoClose: true });
      return;
    }

    if(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER){
      if(formCreateUtente.ruolo === "corsista") {
        if (!formCreateUtente?.id_agenzia && formCreateUtente?.id_agenzia !== "Nessun'agenzia" && formCreateUtente?.id_agenzia === "") {
          alertService.warn("Seleziona un'opzione per l'agenzia", {autoClose: true});
          return;
        }
      }
    }
   
    if(formCreateUtente.ruolo === "partner") {
      if (!formCreateUtente?.id_agenzia || formCreateUtente?.id_agenzia === "") {
        alertService.warn("Seleziona un'opzione per l'agenzia", {autoClose: true});
        return;
      }
    }

    if (formCreateUtente?.id_agenzia === "Nessun'agenzia") {
      delete formCreateUtente?.id_agenzia;
    }

    const transformedUser = UtilityService.transformPropertyName(
      formCreateUtente,
      "ruolo",
      "tipo_utente"
    );
    let finalTransformedUser = UtilityService.transformPropertyName(
      transformedUser,
      "email",
      "username"
    );

    if(userLoggedIn.role === ROLES.PARTNER) {
      finalTransformedUser = {
        ...finalTransformedUser,
        id_agenzia: userLoggedIn?.id_agenzia,
        sconto_default: formCreateUtente?.sconto_default ?? null
      };
    }

    const res = await createUtente(finalTransformedUser);
    let checkoutPartnerList = [];
    if (res?.id) {
      if (corsiUtentiAssignedPerUser?.length > 0) {
        for (const corsoAssigned of corsiUtentiAssignedPerUser) {
          if(userLoggedIn?.role !== ROLES.PARTNER && (formCreateUtente?.ruolo === "course_designer" || formCreateUtente?.ruolo === "docente" || formCreateUtente?.ruolo === "tutor" || formCreateUtente?.ruolo === "corsista")){

            let data = {
              stato_pagamento: corsoAssigned?.stato_pagamento ?? "Non_pagato",
              id_utente: res?.id
            }
            if(corsoAssigned?.corso.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
              data.id_corso = corsoAssigned?.corso?.id_corso;
              data.modalita_erogazione = corsoAssigned?.corso?.modalita_erogazione;
              data.tipo_utente = formCreateUtente?.ruolo;
              await assignCourseToUser(data)
            } else {
              data.id_classe = corsoAssigned?.id_classe
              await createClassiUtenti(data)
            }
          }

          if(userLoggedIn?.role === ROLES.PARTNER){//NEW
            if(corsoAssigned.pagamento_partner === "0") {
              const data = {
                pagamento_partner: corsoAssigned?.pagamento_partner ?? "0",
                sconto_corsista: corsoAssigned?.sconto_corsista ?? "0",
                sconto: corsoAssigned?.sconto, 
                id_classe: corsoAssigned?.id_classe,
                id_utente: res?.id
              }
              await createClassiUtenti(data)
            } 
            else {
              if(corsoAssigned.pagamento_self == "1"){//CARTA
                checkoutPartnerList.push({
                  ...corsoAssigned,
                  corsistaUsername: finalTransformedUser?.username
                });
                console.log(checkoutPartnerList);
                if(checkoutPartnerList.length > 0) {
                  navigate(`/checkout`, { state: { courseData: checkoutPartnerList } });
                }
                checkoutPartnerList = [];
              }
              else if(corsoAssigned.pagamento_self == "0"){//VOUCHER
                let data = {
                  stato_pagamento: corsoAssigned?.stato_pagamento ?? "Pagato",
                  id_utente: res?.id,
                  id_corso: corsoAssigned?.corso?.id_corso,
                  modalita_erogazione: corsoAssigned?.corso?.modalita_erogazione,
                  tipo_utente: formCreateUtente?.ruolo,
                  is_stripe: corsoAssigned.pagamento_self == "1" ? "1" : "0",
                  is_voucher: corsoAssigned.pagamento_self == "0" ? "1" : "0"
                }
                console.log(data);
                await assignCourseToUser(data)
              }
              // checkoutPartnerList.push({
              //   ...corsoAssigned,
              //   corsistaUsername: finalTransformedUser?.username
              // });
              
              // if(corsoAssigned.pagamento_self == "1"){
              //   alert("Bonifico");
              // }
              // else if(corsoAssigned.pagamento_self == "0"){
              //   alert("Iscrivi corsista e Scala voucher");
              // }
            } 
          }
        }
      } 
      //NON ANDRA' PIU AL CHECK OUT
      // if(checkoutPartnerList.length > 0) {
      //   navigate(`/checkout`, { state: { courseData: checkoutPartnerList } });
      // }
      //checkoutPartnerList = [];
      printAllUtenti();
    }
  };

  const renderSelectedDisableUtente = () => {
    return (
      <>
        <span className="d-block fs-4 mb-2">
          <b>Vuoi disabilitare il seguente utente?</b>
        </span>
        <span className="d-block fs-5">
          {selectedUtente?.nome} {selectedUtente?.cognome}{" "}
          <span className="fs-6 small text-muted">
            ({selectedUtente?.username})
          </span>
        </span>
      </>
    );
  };

  const renderSelectedDeleteUtente = () => {
    return (
      <>
        <span className="d-block fs-4 mb-2">
          <b>Vuoi ritirare il seguente invito?</b>
        </span>
        <span className="d-block fs-5">
          {selectedUtente?.nome} {selectedUtente?.cognome}{" "}
          <span className="fs-6 small text-muted">
            ({selectedUtente?.username})
          </span>
        </span>
      </>
    );
  };

  const onDeleteUtente = async () => {
    const obj = { username: selectedUtente?.username };
    await deleteUtente(obj);
    setModalStateUtenti((state) => ({
      ...state,
      showModalDeleteUtente: false,
    }));
    printAllUtenti();
  };

  const onDisableUtente = async () => {
    const obj = { username: selectedUtente?.username };
    const res = await disableUtente(obj);
    if (res) {
      setModalStateUtenti((state) => ({
        ...state,
        showModalDisableUtente: false,
      }));
      printAllUtenti();
    }
  };

  const onResendEmailRegister = async (user) => {
    setSelectedUtente(user);
    const obj = { username: user.username };
    await resendEmail(obj);
  };

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const openAssegnaCorsiModal = (user) => {
    setSelectedUtente(user);
    setModalStateClassiUtenti((state) => ({ ...state, showModalCreateClassiUtenti: true }));
  };

  const openAssegnaScontiModal = (user) => {
    setSelectedUtente(user);
    setModalStateSconti((state) => ({ ...state, showModalCreateSconto: true }));
  };

  const openViewClassiListModal = (user) => {
    setSelectedUtente(user);
    setModalStateClassiUtenti((state) => ({ 
      ...state, 
      showModalViewClassiList: true 
    }));
  };
  
  const actions = [
    {
      icon: 'bi-info-circle text-dark',
      tooltip: ACTION_TYPES.DETAILS,
      label: ACTION_TYPES.DETAILS,
      type: ACTION_TYPES.VIEW,
      condition: () => userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.DOCENTE,
      onClick: (utente) => openInfoModal(utente)
    },
    {
      icon: 'bi-list-nested text-dark',
      tooltip: 'Lista corsi',
      label: 'Lista corsi',
      type: ACTION_TYPES.VIEW,
      condition: (utente) => utente?.abilitato_web == "1" && (utente?.tipo_utente === "corsista"),
      onClick: (utente) => openViewClassiListModal(utente)
    },
/*     {
      icon: 'bi-card-list text-dark',
      tooltip: 'Assegna corsi',
      label: 'Assegna corsi',
      type: ACTION_TYPES.MANAGER,
      condition: (utente) => userLoggedIn.tipo_utente === "partner" && utente.abilitato_web == "1",
      onClick: (utente) => openAssegnaCorsiModal(utente)
    }, */
    {
      icon: 'bi-card-list text-dark',
      tooltip: 'Assegna sconti',
      label: 'Assegna sconti',
      type: ACTION_TYPES.CONFIG,
      condition: (utente) => utente.tipo_utente === "partner", //&& utente.abilitato_web == "1",//NEW: assegnazione sconto possibile anche se partner non attivo
      onClick: (utente) => openAssegnaScontiModal(utente)
    },
    {
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      label: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER,
      onClick: (utente) => openEditModal(utente)
    },
    {
      icon: 'bi-trash-fill text-danger',
      tooltip: 'Ritira invito registrazione',
      label: 'Ritira invito registrazione',
      type: ACTION_TYPES.MANAGER,
      condition: (utente) => utente.abilitato_web != "1",
      onClick: (utente) => openDeleteModal(utente)
    },
    {
      icon: 'bi-send-check text-success',
      tooltip: 'Reinvia email registrazione',
      label: 'Reinvia email registrazione',
      type: ACTION_TYPES.MANAGER,
      condition: (utente) => utente.abilitato_web != "1",
      onClick: (utente) => onResendEmailRegister(utente)
    },
    {
      icon: 'bi-person-fill-slash text-danger',
      tooltip: 'Disabilita utente',
      label: 'Disabilita utente',
      type: ACTION_TYPES.MANAGER,
      condition: (utente) => utente.abilitato_web == "1" && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER),
      onClick: (utente) => openDisableModal(utente)
    }
  ]

  return (
    <>
        <div
          className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}
          style={{ minHeight: "700px" }}>
            <div className="container">
              <div className="d-flex justify-content-between custom-card-header">
                <div className="d-flex gap-3 custom-card-title my-2">
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-people-fill fs-2`}></i>
                  </div>
                  <div className="align-self-center">
                    <span className="fs-4 d-block">
                      <i>
                        <b>Gestione Utenti</b>
                      </i>
                    </span>
                  </div>
                </div>
                <div className='align-self-center my-2'>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={openModalCreateUtente}
                  >
                    Crea utente
                  </button>
                </div>
              </div>
              <div className='mt-4'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateUtenti.isLoadingUtenteByParams}
                  searchNodeType={
                   userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER ?
                    ([
                    {nodeType: "input", name: "nome"},
                    {nodeType: "input", name: "cognome"},
                    {nodeType: "input", name: "username", placeholder: "email"},
                    {nodeType: "select", name: "tipo_utente"},
                    {nodeType: "select", name: "abilitato_web"}
                  ]) : (
                  [ {nodeType: "input", name: "nome"},
                    {nodeType: "input", name: "cognome"},
                    {nodeType: "input", name: "username", placeholder: "email"},
                    {nodeType: "select", name: "abilitato_web"},
                    {nodeType: "select", name: "stato_pagamento", placeholder: "tipo di pagamento"}
                  ]
                  )
                }
                />
              </div>
              <>
           {  !loadingStateUtenti.isLoadingUtenteByParams ? (
            <>
                 {(!utenti || utenti?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono utenti da mostrare.</p>
                    </div>) : (
                    <>
                    <i>*gli utenti sono ordinati per ultima data di iscrizione ad un corso</i>
                    <CustomTable
                      data={utenti}
                      orderBy={orderBy}
                      orderType={orderType}
                      handleOrder={handleOrder}
                      columns={userConfigTable}
                      actions={actions}
                    />
             <div className="d-flex justify-content-end mt-1">
               <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                  />
             </div>
              </>
             )}
            </>
           ) : (
            <LoadingTable loadingCol={6}/>
           )}
             </>
            </div>
        </div>
      <CustomModal
        show={modalStateUtenti.showModalInfoUtente}
        onHide={handleCloseModal}
        headerText="Informazioni utente"
        size={"lg"}
        body={<UserInfo userData={selectedUtente} />}
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />
      <CustomModal
        show={modalStateUtenti.showModalCreateUtente}
        onHide={handleCloseModal}
        headerText="Crea utente"
        size={"lg"}
        btnText={"Crea utente"}
        body={
          <CreateUser
            userLoggedIn={userLoggedIn}
            formCreateUtente={formCreateUtente}
            setFormCreateUtente={setFormCreateUtente}
            showModalCreateUtente={modalStateUtenti.showModalCreateUtente}
            corsiUtentiAssignedPerUser={corsiUtentiAssignedPerUser}
            setCorsiUtentiAssignedPerUser={setCorsiUtentiAssignedPerUser}
            selectedAgenzia={selectedAgenzia}
            setSelectedAgenzia={setSelectedAgenzia}
            formatCourseData={formatCourseData}//NEW
          />
        }
        closeButton={true}
        isLoading={loadingStateUtenti.isLoadingUtentiCreating}
        onUndoChanges={handleCloseModal}
        onSave={onCreateUtente}
        hideSaveBtn={
          userLoggedIn?.role === ROLES.PARTNER 
            ? corsiUtentiAssignedPerUser?.length === 0 
            : false
        }
      />
      <CustomModal
        show={modalStateUtenti.showModalDisableUtente}
        onHide={handleCloseModal}
        headerText="Disabilita utente"
        size={"md"}
        variant={"danger"}
        btnText={"Disabilita"}
        body={renderSelectedDisableUtente()}
        isLoading={loadingStateUtenti.isLoadingUtentiDisable}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onDisableUtente}
      />
      <CustomModal
        show={modalStateUtenti.showModalDeleteUtente}
        onHide={handleCloseModal}
        headerText="Ritira invito"
        size={"md"}
        variant={"danger"}
        btnText={"Ritira"}
        body={renderSelectedDeleteUtente()}
        isLoading={loadingStateUtenti.isLoadingUtentiDeleting}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onDeleteUtente}
      />
      <CustomModal
        show={modalStateUtenti.showModalUpdateUtente}
        onHide={handleCloseModal}
        headerText="Aggiorna informazioni utente"
        size={selectedUtente?.abilitato_web == 1 ? "lg" : "md"}
        variant={"primary"}
        btnText={"Salva modifiche"}
        body={
          (selectedUtente?.abilitato_web == 1) ? 
          <InputUserinfo
            userData={selectedUtente}
            isUpdateUserFromModal={true}
            onHide={handleCloseModal}
            printAllUtenti={printAllUtenti}
          />
          : 
          <UpdateUserPendingForm 
          setFormDataUpdateUserPending={setFormDataUpdateUserPending}
          formDataUpdateUserPending={formDataUpdateUserPending}
          onUndoChanges={handleCloseModal}
          userData={selectedUtente}
          printAllUtenti={printAllUtenti}
          />
        }
        closeButton={true}
        onUndoChanges={handleCloseModal}
        hideSaveBtn={true}
        footerStyle={"d-none"}
      />

      <CustomModal
        show={modalStateClassiUtenti.showModalViewClassiList}
        onHide={handleCloseModal}
        headerText={`Lista corsi - ${selectedUtente?.nome} ${selectedUtente?.cognome}`}
        size={"xl"}
        body={<ClassiListManager userId={selectedUtente?.id_utente} />}
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />

      {selectedUtente?.tipo_utente === "partner" && (
      <AssegnaScontoManager 
        selectedUser={selectedUtente} 
        modalStateSconti={modalStateSconti}
        onHide={handleCloseModal}
      />
      )}


      <AssegnaCorsiModal
        selectedUser={selectedUtente}
        setselectedUser={setSelectedUtente}
        setModalStateClassiUtenti={setModalStateClassiUtenti}
        showModalCreateClassiUtenti={modalStateClassiUtenti.showModalCreateClassiUtenti}
        setSelectedUser={setSelectedUtente}
      />
    </>
  );
};

export default GestioneUtentiPage;
